export function setcatalogo(catalogo) {
  return {
    type: 'SET_CATALOGO',
    catalogo,
  };
}
